"use strict";

exports.__esModule = true;
exports.DataViewPropTypes = void 0;
var PropType = {};
if (process.env.NODE_ENV !== 'production') {
  PropType = {};
}
var DataViewPropTypes = PropType;
exports.DataViewPropTypes = DataViewPropTypes;